import { JourneysNotFound } from '@/components/purchase/journey/JourneysNotFound';
import { NonTripOffersNotFound } from '@/components/purchase/journey/NonTripOffersNotFound';
import { SearchWidgetWrapper } from '@/components/search-widget';
import { getPurchaseFlowBookingById } from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  nonTripOffersSelector,
  outboundDataSelector,
  purchaseFlowBookingSelector,
} from '@/features/purchase/purchaseSelectors';
import { usePageTitle } from '@/hooks/usePageTitle';
import { persistor } from '@/store';
import { useDispatch, useSelector } from '@/store/utils';
import { purchaseFlowJourneyOrOfferPaths } from '@/utils/purchase';
import { type FC, useCallback, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

interface PurchaseProps {}

const Purchase: FC<PurchaseProps> = () => {
  const dispatch = useDispatch();
  const purchaseFlowBooking = useSelector(purchaseFlowBookingSelector);
  const outboundData = useSelector(outboundDataSelector);
  const inboundData = useSelector(inboundDataSelector);
  const nonTripOffersData = useSelector(nonTripOffersSelector);
  const navigate = useNavigate();
  const location = useLocation();

  usePageTitle('purchase');

  const handlePurchaseBookingFetching = useCallback(async () => {
    try {
      await dispatch(
        getPurchaseFlowBookingById(purchaseFlowBooking?.id)
      ).unwrap();
    } catch {
      await persistor.purge();
    }
  }, [dispatch, purchaseFlowBooking?.id]);

  useEffect(() => {
    const purchaseFlowBookingKeys = Object.keys(purchaseFlowBooking ?? {});

    if (purchaseFlowBooking?.id && purchaseFlowBookingKeys.length === 1) {
      handlePurchaseBookingFetching();
    } else if (purchaseFlowBookingKeys.length > 0) {
      navigate('/purchase/checkout');
    }
  }, [handlePurchaseBookingFetching, navigate, purchaseFlowBooking]);

  return (
    <PersistGate loading={null} persistor={persistor}>
      <>
        {['/purchase', ...purchaseFlowJourneyOrOfferPaths].includes(
          location.pathname
        ) && <SearchWidgetWrapper />}
        <Outlet />
        <JourneysNotFound
          outboundData={outboundData}
          inboundData={inboundData}
        />
        <NonTripOffersNotFound {...nonTripOffersData} />
      </>
    </PersistGate>
  );
};

export default Purchase;
